import React, { useEffect, useState, useRef } from "react";
import "../styles/HeroStyles.css";
import productsData from "../data/products.json";
import GoogleReviews from "./GoogleReviews";
import DownloadCatalogue from "./DownloadCatalogue";

const Hero = () => {
  const placeId = "ChIJfyz0dhz9DDkRE5wiG3J_Njw";
  const [isFormVisible, setFormVisible] = useState(false);
  const [customers, setCustomers] = useState(0);
  const [teamMembers, setTeamMembers] = useState(0);
  const [positiveReviews, setPositiveReviews] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [isInView, setIsInView] = useState(false);

  const statsRef = useRef(null);

  useEffect(() => {
    // Prevent scrolling when the popup is visible
    document.body.style.overflow = isFormVisible ? "hidden" : "auto";

    const animateNumber = (start, end, step, callback) => {
      let current = start;
      const interval = 1000 / (end - start) / step;
      const timer = setInterval(() => {
        current += step;
        if (current >= end) {
          clearInterval(timer);
          current = end;
        }
        callback(current);
      }, interval);
    };

    if (isInView) {
      const countStats = () => {
        animateNumber(0, 10000, 200, (value) => setCustomers(value));
        animateNumber(0, 160, 5, (value) => setTeamMembers(value));
        animateNumber(0, 400, 20, (value) => setPositiveReviews(value));
      };
      countStats();
      const interval = setInterval(countStats, 5000); // Restart counting every 20 seconds
      return () => clearInterval(interval);
    }
  }, [isInView, isFormVisible]); // Add isFormVisible to the dependency array

  useEffect(() => {
    const categories = productsData.products.map(
      (product) => product.categoryName
    );

    const typeCategory = (category) => {
      return new Promise((resolve) => {
        let index = 0;
        const typingInterval = setInterval(() => {
          setSearchValue(category.substring(0, index + 1));
          index++;
          if (index === category.length) {
            clearInterval(typingInterval);
            setTimeout(() => {
              resolve();
            }, 2000);
          }
        }, 100);
      });
    };

    const cycleCategories = async () => {
      await typeCategory(categories[currentCategoryIndex]);
      setCurrentCategoryIndex(
        (prevIndex) => (prevIndex + 1) % categories.length
      );
    };

    const cycleInterval = setInterval(cycleCategories, 5000);
    return () => clearInterval(cycleInterval);
  }, [currentCategoryIndex]);

  {
    /*useEffect(() => {
    if (searchValue) {
      const currentCategory = productsData.products.find((product) =>
        product.categoryName.toLowerCase().includes(searchValue.toLowerCase())
      );
      if (currentCategory) {
        setHighlightedImage(require(`../assets/${currentCategory.heroimage}`));
      }
    } else {
      setHighlightedImage("");
    }
  }, [searchValue]);*/
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.1 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, []);

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center p-lg-4 mb-0">
      <div className="row bg-white rounded-4 p-lg-4">
        <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-center">
          <DownloadCatalogue />

          <div
            className="stats row justify-content-center align-items-center mt-0 g-5"
            ref={statsRef}
          >
            <div className="stat-block col-md-4 text-center">
              <div className="fs-3 fw-bold number text-nowrap">
                {customers}+
              </div>
              <div className="text-muted fw-bold text-nowrap">CUSTOMERS</div>
            </div>
            <div className="stat-block col-md-4 text-center">
              <div className="fs-3 fw-bold number text-nowrap">
                {teamMembers}+
              </div>
              <div className="text-muted fw-bold text-nowrap">TEAM MEMBERS</div>
            </div>
            <div className="stat-block col-md-4 text-center">
              <div className="fs-3 fw-bold text-nowrap">4.8/5</div>
              <div className="text-muted fw-bold text-nowrap">
                POSITIVE REVIEWS
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 d-flex flex-column align-items-center position-relative py-4 mt-3">
          <GoogleReviews placeId={placeId} />
        </div>
      </div>
    </div>
  );
};

export default Hero;
